module.exports = __webpack_public_path__ + "img/face13.16f59cba.jpg";